import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import { Box } from '@mui/material';

import { NameInput } from '@/components/NameInput';
import { TABNAME_MAX_LENGTH } from '@/constants/name';
import { DataHubCard } from '@/features/DataHub/components/DataHubCard';

const exportNameInputSx = {
  display: 'inline-flex',
  width: 'fit-content',
  '& .name-input': { flex: 'none', width: 'fit-content' },
  '& .name-input .MuiInputBase-formControl': { width: 'auto' },
  '& .name-input .MuiInputBase-input': {
    fieldSizing: 'content',
    minWidth: '14ch',
    maxWidth: `${TABNAME_MAX_LENGTH + 1}ch`
  }
} as const;

export const ExportNameCard = ({
  exportName,
  exportNameError,
  onChange
}: {
  exportName: string;
  exportNameError?: string | null;
  onChange: (value: string) => void;
}) => {
  return (
    <DataHubCard
      expandable={false}
      title={
        <>
          <Box
            component='span'
            sx={exportNameInputSx}
          >
            <NameInput
              error={exportNameError ?? undefined}
              isEmpty={exportName.trim().length === 0}
              maxLength={TABNAME_MAX_LENGTH}
              size={18}
              value={exportName}
              onChange={onChange}
            />
          </Box>
          <EditOutlinedIcon sx={{ fontSize: '16px' }} />
        </>
      }
    />
  );
};
